
import { RootAction, State } from 'store/state';
import { setIsYieldTagModalOpen } from 'store/state/app/actions';
import { isYieldTagModalOpenSelector } from 'store/state/app/selectors';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { YieldModal } from './yield-tag';
import { DecodedRouteParams, Route } from 'config/routes';
import { NavigationOptions } from 'store/state/router/actionPayloads';
import { navigateTo as navigateToAction } from 'store/state/router/actions';
import { routeNameSelector, getRouteParams } from 'store/state/selectors/router';

const mapStateToProps = (state: State) => ({
  poiId: isYieldTagModalOpenSelector(state),
  routeName: routeNameSelector(state),
  routeParams: getRouteParams(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onClose: () => dispatch(setIsYieldTagModalOpen(null)),
  navigate: (name: Route, params?: DecodedRouteParams, opts?: NavigationOptions) =>
    dispatch(navigateToAction(name, params, opts)),
});

export default connect(mapStateToProps, mapDispatchToProps)(YieldModal);
